import { useState } from "react";
import { Info } from "lucide-react";

export function InfoTip({ text, testid }) {
  const [open, setOpen] = useState(false);
  if (!text) return null;
  return (
    <span className="relative inline-flex align-middle" data-testid={testid}>
      <button type="button" aria-label="Spiegazione" tabIndex={-1}
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOpen((o) => !o); }}
        onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}
        className="ml-1 text-slate-400 hover:text-indigo-600 align-middle transition-colors duration-150">
        <Info className="w-3.5 h-3.5" />
      </button>
      {open && (
        <span className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-1.5 w-56 normal-case tracking-normal font-normal text-xs leading-snug text-left bg-slate-900 text-white rounded-md px-3 py-2 shadow-lg pointer-events-none">
          {text}
        </span>
      )}
    </span>
  );
}
